import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteBookById, replaceBook } from "../Store/api/books";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ModalPortal } from "../components/ModalPortal";
import { CustomModal } from "./CustomModal";
import { classesStatus, getBookStatus, modalVariations } from "./book_detail_tabs/Overview";
import { CustomSelect } from "./CustomSelect";

const indicatorSeparatorStyle = {
  alignSelf: "stretch",
  marginBottom: 8,
  marginTop: 8,
  width: 0,
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

export const CustomOptions = ({
  bookId,
  _id = "",
  bookStatus,
  setRefetch,
  books = [],
  ...props
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dorpdownRef = useRef(null);
  const [title, setTitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showDropDown, setShowDropdown] = useState(false);
  const [currentSelectedBook, setCurrentSelectedBook] = useState({});

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleChangeStatus = () => {
    navigate(`/dashboard/bookshelf/overview/${bookId}`);
  };

  const onHide = useCallback(() => {
    setShowModal(false);
    setTitle("");
    setCurrentSelectedBook({});
  }, []);

  const handleClickOutside = (event) => {
    if (dorpdownRef.current && !dorpdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };
  const handleDownload = () => {};

  const deleteBook = () => {
    const promise = new Promise((resolve, reject) =>
      (currentSelectedBook?.label && currentSelectedBook?.value) ? 
        dispatch(replaceBook({
          oldBookId: bookId || _id,
          newBookId: currentSelectedBook.value,
          onSuccess: () => {
            setRefetch();
            resolve();
            onHide();
          },
          onError: () => {
            reject();
          },
          onEnd: () => {
            handleClick();
          },
        })):
        dispatch(
          deleteBookById({
            bookId: bookId || _id,
            status: bookStatus,
            onSuccess: () => {
              setRefetch();
              resolve();
              onHide();
            },
            onError: () => {
              reject();
            },
            onEnd: () => {
              handleClick();
            },
          })
        )
    );

    toast.promise(promise, {
      pending: "Book deletion in progress",
      success: "Book deleted successfully",
      error: "Error while deleting book",
    });
  };

  const book_status = getBookStatus({ ...props, bookStatus });
  const classDetails = classesStatus(props.classesArray)[book_status];

  return (
    <>
      <ModalPortal>
        <CustomModal
          is_delete
          onHide={onHide}
          showModal={showModal}
          onAction={deleteBook}
          title_matched={['private_upcoming', 'published_upcoming'].includes(book_status) ? !(props.title === title && currentSelectedBook?.label): !(props.title === title)}
          // pass additional parameter for action button style. based on book title and title enter by user.
          {...modalVariations(classDetails?.courseName || "")?.[book_status]}
        >
          { ['private_upcoming', 'published_upcoming'].includes(book_status) &&
            <div className="d-flex flex-column">
              <p className="mb-0 mt-2">
                Choose a book replacement for all associated classes. Any assigned activities will need to be reassigned.
              </p>
              <div className="form-group mb-0 w-100">
                <CustomSelect
                  customStyle={{
                    control: (base, state) => ({
                      ...base,
                      border: "none !important",
                      background: "#fafaf9",
                      boxShadow: "none",
                      borderBottom: state.isFocused
                        ? "1px solid #2e2e2d !important"
                        : "1px solid #2e2e2d !important",
                      "&:hover": {
                        borderBottom: "1px solid #2e2e2d", // Keep border on hover
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      marginTop: 0, // This removes the gap between control and dropdown
                      border: "1px solid grey"
                    }),
                  }}
                  isClearable={false}
                  className="w-100 mb-0"
                  placeholder="Select book"
                  value={books.filter(
                    (item) => item._id === currentSelectedBook.value
                  ).map(item => ({ value: item._id, label: item.title }))}
                  options={books.map(item => ({ value: item._id, label: item.title }))}
                  handleChange={(value) => {
                    setCurrentSelectedBook(value);
                  }}
                  components={{
                    IndicatorSeparator,
                  }}
                />
              </div>
            </div>
          }
          {!['private_previous', 'private_current', 'published_current', 'published_previous'].includes(book_status) &&
            <div className="d-flex flex-column">
              <p className="mb-0">
                Please type the book title{" "}
                <span className="fw-500">“{props.title}”</span> below to confirm
                deletion.
              </p>
              <div className="form-group mb-0">
                <input
                  type="text"
                  name="title"
                  value={title}
                  placeholder="Title of the textbook"
                  onChange={(e) => setTitle(e.target.value)}
                  className="form-control pl_0 book_detail_overview_title mb-0"
                />
              </div>
            </div>
          }
        </CustomModal>
      </ModalPortal>
      <div ref={dorpdownRef} className="tab-content" id="myTabContent">
        <div
          id="Contents"
          role="tabpanel"
          className="tab-pane fade show active"
          aria-labelledby="Contents-tab"
        >
          <div className="custom_droup_down_book_shelf padding_title_logo">
            <button
              type="button"
              className="add_more_btn_create"
              onClick={handleClick}
            >
              <img
                className="book_shelf_options"
                style={{ marginRight: "0px" }}
                src="/assets/images/more-vertical.svg"
                alt="ico here"
              />
            </button>
            {showDropDown && (
              <ul
                style={{
                  borderRadius: "5px",
                  right: 26,
                  top: 0,
                  borderColor: "#BAB5B0",
                  boxShadow: "3px 3px 10px 0px rgba(0, 0, 0, 0.07)",
                  width: "max-content",
                }}
              >
                <div
                  className="d-flex flex-column"
                  style={{ padding: "10px 15px 6px 15px" }}
                >
                  <p
                    className="cursor book_shelf_options_dropDown"
                    onClick={handleChangeStatus}
                  >
                    Change Status
                  </p>
                  <p
                    className="cursor book_shelf_options_dropDown"
                    onClick={handleDownload}
                  >
                    Download
                  </p>
                  <p
                    className="cursor book_shelf_options_dropDown"
                    onClick={() => setShowModal(true)}
                  >
                    Delete
                  </p>
                </div>
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
